import * as React from "react";
import { useCallback } from "react";
import { styled } from "@mui/material";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
// import { isIos } from "../../../installAppPopover/addToHomeScreenPopover";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const HowItWorksTopLinkContainer = styled("div")({
  background: "transparent",
  height: "20px",
  width: "100%",
  display: "flex",
  flexDirection: "row-reverse",
});

const HowItWorksLink = styled("a")({
  color: KahunColorMap.White,
  fontSize: "11px",
  lineHeight: "14px",
  fontWeight: 500,
  textDecoration: "none",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface HowItWorksTopLinkProps {
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

//region [[ Texts ]]
const HOW_IT_WORKS_LINK_TEXT = "How it works?";
//endregion [[ Texts ]]
const HOW_IT_WORKS_LINK_URL = "https://kahun.com/how-it-works/";

export const HowItWorksTopLink = ({ ...props }: HowItWorksTopLinkProps) => {
  const handleHowItWorksClick = useCallback(() => {
    evt({
      category: CATEGORY.NAVIGATION,
      action: ACTION.NAVIGATED_TO_HOW_IT_WORKS,
    });
  }, []);

  // if (!isIos()) {
  //   return null;
  // }
  return (
    <HowItWorksTopLinkContainer className={props.className}>
      <HowItWorksLink
        className={"how-it-works-link"}
        href={HOW_IT_WORKS_LINK_URL}
        target={"_blank"}
        onClick={handleHowItWorksClick}
      >
        {HOW_IT_WORKS_LINK_TEXT}
      </HowItWorksLink>
    </HowItWorksTopLinkContainer>
  );
};
